import { ChangeDetectionStrategy, Component, computed, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IKuiModalAction, KuiModalModule } from 'app/key-ui';
import { KuiModalRefComponent } from 'app/key-ui/modal/modal-ref.component';
import { SaveVideoConfirmationComponent } from '../save-video-confirmation/save-video-confirmation.component';

@Component({
    selector: 'key-save-video-modal',
    imports: [
        TranslateModule,
        KuiModalModule,
        SaveVideoConfirmationComponent
    ],
    templateUrl: 'save-video-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveVideoModalComponent extends KuiModalRefComponent<any> implements OnInit {
    modalActions: IKuiModalAction[];

    title = computed(() => this.data.title);

    constructor(private i18n: TranslateService) {
        super();
    }   
  
    ngOnInit() {
        this.modalActions = [{
            text: this.i18n.instant('DIALOG.CANCEL'),
            style: 'secondary',
            keypress: 27,
            action: () => {
                this.actions.close();
            },
        }, {
            text: this.i18n.instant('DIALOG.SAVE'),
            style: 'primary',
            keypress: 13,
            action: () => {
                this.actions.save();
            },
        }];
    }
}
